import { createStyles, SimpleGrid, Text, rem } from "@mantine/core";
import PageContainer from "./layout/PageContainer";
import SectionHeader from "./layout/SectionHeader";
import { IconPlaneArrival, IconCrown, IconShoppingCart } from "@tabler/icons-react";
import { homeSectionPy } from "../constant/Responsive";

const features = [
  {
    icon: IconPlaneArrival,
    title: "每週空運直送",
    description: "與馬來西亞彭亨州榴槤園合作，新鮮直送香港。",
  },
  {
    icon: IconCrown,
    title: "嚴選品質保證",
    description: "D197 貓山王、D200 黑刺、D24 蘇丹王，原產地直供。",
  },
  {
    icon: IconShoppingCart,
    title: "批發零售皆可",
    description: "食肆、餐廳、甜品店批發；散客零售。急凍產品預約送貨。",
  },
];

const useStyles = createStyles((theme) => ({
  section: {
    paddingTop: rem(homeSectionPy.md),
    paddingBottom: rem(homeSectionPy.md),
    backgroundColor: theme.colors.gray[0],
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
    [theme.fn.smallerThan("sm")]: {
      paddingTop: rem(homeSectionPy.base),
      paddingBottom: rem(homeSectionPy.base),
    },
  },
  card: {
    padding: rem(20),
    borderRadius: theme.radius.md,
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray[2]}`,
    height: "100%",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: theme.colors.orange[2],
    },
  },
  icon: {
    width: 44,
    height: 44,
    borderRadius: theme.radius.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.orange[0],
    color: theme.colors.orange[7],
    marginBottom: theme.spacing.md,
    border: `1px solid ${theme.colors.orange[2]}`,
  },
  title: {
    fontFamily: theme.headings?.fontFamily || '"Noto Serif TC", serif',
    fontWeight: 600,
    fontSize: theme.fontSizes.md,
    color: theme.colors.gray[8],
    marginBottom: theme.spacing.xs,
    letterSpacing: "0.03em",
  },
  description: {
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
    lineHeight: 1.7,
  },
}));

export default function FeaturesSection() {
  const { classes } = useStyles();

  return (
    <section className={classes.section}>
      <PageContainer>
        <SectionHeader
          title="為什麼選擇猫山王朝"
          subtitle="專注馬來西亞頂級榴槤供應，服務香港餐飲及零售客戶。"
          size="md"
          animate
          compact
        />
        <SimpleGrid cols={3} spacing={20} breakpoints={[{ maxWidth: "md", cols: 1 }]}>
          {features.map((f) => (
            <div key={f.title} className={classes.card}>
              <div className={classes.icon}>
                <f.icon size={22} stroke={1.5} />
              </div>
              <Text className={classes.title}>{f.title}</Text>
              <Text className={classes.description}>{f.description}</Text>
            </div>
          ))}
        </SimpleGrid>
      </PageContainer>
    </section>
  );
}
